import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { createEffectFactory } from '@recruitee/ngrx';

import { NotificationsCounterHttpService } from './notification-counter-http.service';
import { NotificationsCounterActions } from './notification-counter.store';

@Injectable({ providedIn: 'root' })
export class NotificationsCounterEffects {
  public effects = createEffectFactory(NotificationsCounterActions, this.actions$);

  public fetch$ = this.effects(NotificationsCounterActions.fetch, () =>
    this.notificationsCounterHttpService.fetch(),
  );

  constructor(
    private actions$: Actions,
    private notificationsCounterHttpService: NotificationsCounterHttpService,
  ) {}
}
